import urls from "global/constants/UrlConstants";
import { getNoAuthCallParams, makeCall } from "utils/service";

export const subscribeWebsite = async (email: string): Promise<any> => {
  try {
    const callParams = await getNoAuthCallParams("POST", { email });
    const response: any = await makeCall(urls.SUBSCRIBE, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};
